import { render, staticRenderFns } from "./SidebarApplySenderId.vue?vue&type=template&id=07a17aa2&"
import script from "./SidebarApplySenderId.vue?vue&type=script&lang=js&"
export * from "./SidebarApplySenderId.vue?vue&type=script&lang=js&"
import style0 from "./SidebarApplySenderId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports